import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import CountDown from "../components/CountDown2"
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import MenuIcon from '@material-ui/icons/Menu';
import DoneIcon from '@material-ui/icons/Done';
import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import Numpad from "../components/Numpad2"
import { Link } from "react-router-dom";

import TopBar from '../components/TopBar';
import NumDisplay from '../components/NumDisplay2';
import Paper from '@material-ui/core/Paper';

import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';
import _ from 'lodash';
import moment from "moment";
import CompRank from './CompRank';
import * as LHELPER from '../components/LessonHelper';
import { isMobile } from "react-device-detect";
const DWIDTH = 1024;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
  var re = /^([0-9]{6,20})$/;
  return re.test(phone);
};

const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;

const defaultSetting = {type:['LB_0'],
times:1,
rows:3,
showTime:3,
answerTime:3,
qCount:10,
maxNumber:10,
digits:1,
digits1:1,
digits2:1,
point:0,
percent:80,
displaySetting:0,
displayShow:0,
lessThan0:0,
largerThan:0,
roundNumber:0,
isReversed:0,
dr1:0,
dr2:0,
dba:1,
ssp:0,
}
var _this;

class CompHome extends React.Component {
  state = {
    viewDidLoad: false,
  };
  constructor(props) {
    super();
    _this = this;

    this.state={isPlaying:false,showRank:false,questions:[],answerInput:"",showNumPad:false,showCountDown:false,startTime:0,nextTime:props.nextTime,showLock:true,curSetIndex:0,sets:props.part.sets}
    _this.audio = new Audio("assets/sound/inner_bg.mp3");
  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  componentDidMount() {
    let alist = this.props.aList;
    _this.setState({sAudios:[alist["s1"],alist["s2"],alist["s3"]],
      fAudios:[alist["w1"],alist["w2"],alist["w3"]]})
    _this.setState({yAudio:alist["yay"]});
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    const { curSetIndex,sets,nextTime } = _this.state;
    if(_this.props.partIndex!=0)
    {
      _this.setState({showRank:true});
      setTimeout(()=>{

        _this.setState({showRank:false})
      },nextTime*1000/2);
    }
    setTimeout(()=>{

      _this.setState({showLock:false})
      _this.startLesson();
    },nextTime*1000);

    //let encrypted = STATIC.encryptStringWithRsaPublicKey("JK1234");
    //console.log(encrypted);


    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    //this.loadBingo();
  }
  async loadBingo(){
    let sDoc = await firebase.firestore().collection('Marathon').doc("#Setting").get();
    //console.log(sDoc.exists)
    if(sDoc.exists)
    {
      let setting = sDoc.data();
      setting.id = sDoc.id;
      if(moment(setting.endTime).isBefore(moment())||moment(setting.startTime).isAfter(moment()))
      {

        return;
      }
      _this.setState({setting});

    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };



  getName(fullname)
  {
    return _.last(fullname.split(' '));
  }
  async startLesson() {

    // console.log(questions);
    // return;
    let questions = _this.state.sets[_this.state.curSetIndex].questions;
    //console.log(questions);
      _this.setState({answering:false, showCountDown: false, trial: false, questions, starting: true, curIndex: 0, answerInput: '', message: '' }, () => this.progressQuestion());

  }
  progressQuestion() {

      _this.setState({ showCountDown: false, showing: true });
  }
  isShowEnd() {
    _this.setState({ showing: false, showCountDown: true,answerInput:"",startTime:moment().valueOf() }, () => {
      if(!isMobile)
      {
        _this.answerInput.focus();
      }
      //console.log("Show Keyboard");
    });
    //console.log("start countdown");
  }
  endCountDown() {
    //console.log("end coutdown");
    _this.confirmAnswer();
  }
  handleKeydown = e => {

    if(e.keyCode=="13")
    {
      if(_this.state.showCountDown)
      _this.confirmAnswer();
    }
    else {
      let new_value = (_this.state.answerInput||"")+e.key;
      if(e.keyCode==8)
      {
        if((_this.state.answerInput||"").length>0)
        new_value = (_this.state.answerInput||"").slice(0, -1);
      }
      //console.log(parseF)
      if(isNaN(new_value)&&new_value!="-")
      {
        e.preventDefault();
      }
    }

  }
  confirmAnswer() {
    if (!_this.state.starting)
      return;
    if(_this.state.answering)
    return;
      const { curSetIndex,sets,startTime } = _this.state;
    _this.setState({answering:true});
    let q = _this.state.questions[_this.state.curIndex];
    let answer = _this.state.answerInput;
    let curSet = sets[curSetIndex];
    let remain = Number(curSet.config.answerTime)*1000- (moment().valueOf()-moment(startTime).valueOf());

      if (Number(q.result) == Number(answer)&&(answer!=undefined&&answer!=null&&answer.trim().length>0)) {
      q.status = 1;
      q.point_r = 0;
      if(remain>0&&curSet.config.point_r&&Number(curSet.config.point_r)>0)
      {
        q.point_r = Number(curSet.config.point_r)*remain;
      }
    }
    else {
      q.status = 0;
    }
    q.answer = answer;
    let message = (<span style={{ color: "#fff8ad", fontSize: '10rem' }}><DoneIcon style={{ fontSize: '10rem' }} /></span>);
    if (q.status == 0) {
      message = (<span style={{ color: "red", fontSize: '10rem' }}>X</span>);
      
        let audio = _.sample(_this.state.fAudios);
        audio.currentTime=0;
        audio.play();
      

    }
    else {
      
        let audio = _.sample(_this.state.sAudios);
        audio.currentTime=0;
        audio.play();

    }



    _this.setState({ showCountDown: false, message, answerInput: '' });
    let curIndex = _this.state.curIndex;
    if (curIndex < _this.state.questions.length - 1)
      setTimeout(function() {
        _this.setState({answering:false, curIndex: curIndex + 1, answerInput: '', message: '' }, () => _this.progressQuestion());
      }, 2000);
    else {
      if (_this.state.starting) {
        message = (<span style={{ color: "#fff8ad", fontSize: '5rem' }}>{!_this.state.trial?"Bravo!!":false}</span>);
        
          setTimeout(function() {
          _this.state.yAudio.currentTime=0;
          _this.state.yAudio.play();
    },1000)
        
        setTimeout(function() {
          _this.setState({answering:false, message, answerInput: '', starting: false });

            _this.onLessonEnd(_this.state.questions);

        }, 2000);
      }
      else {
        setTimeout(function() {
          _this.setState({answering:false, message: '', answerInput: '', questions: [] });
        }, 2000);
      }


    }
  }

  async onLessonEnd() {
    const { curSetIndex,sets } = _this.state;
    if(curSetIndex<sets.length-1)
    {
      _this.props.onSetEnd(_this.state.sets[curSetIndex].questions,curSetIndex,0);
      _this.setState({curSetIndex:curSetIndex+1,nextTime:_this.props.part.time,showLock:true,showCountDown:false,showRank:true},()=>setTimeout(()=>{
        _this.setState({showCountDown:true,showLock:false,showRank:false},()=>_this.startLesson());
      },_this.props.part.time*1000))

    }
    else {
      _this.props.onSetEnd(_this.state.sets[curSetIndex].questions,curSetIndex,0,true);

      STATIC.NotificationManager.success("Chúc mừng bạn đã hoàn thành bài thi")
    }
  }
  handleInputClick(value) {
    if (_this.state.showing || _this.state.message || _this.state.questions.length == 0) {
      //  _this.setState({answerInput});
      return;
    }
    let answerInput = _this.state.answerInput;
    if (value == 'Enter') {
      _this.confirmAnswer();
    }
    else
      if (value != "-1") {
        if (answerInput.length < 7)
          answerInput += value;
        _this.setState({ answerInput });
      }
      else {
        if (answerInput.length > 0) {
          answerInput = answerInput.slice(0, -1);
          _this.setState({ answerInput });
        }
      }
//_this.answerInput.focus();
  }

  render() {
    const { classes,t,comp } = this.props;
    const { loading, wWidth, wHeight,curSetIndex,showCountDown,sets,questions,nextTime,showLock,showNumPad,showTime,showing,curIndex,message,showRank,answerInput } = this.state;
    let width = 1024;
    let height = 640;

    // if (wWidth < width) {
    //   width = wWidth;
    // }

      height = wHeight;

    let sRate = 1024 / 640;
    let tRate = 1371 / 848;
    let bRate = 615 / 47;
    let mRate = 83 / 372;
    let bbRate = 27/43;
    let asRate = 242 / 2048;
    let tsRate = 1371/2048;
    let bsRate = 615/2048;
    let bbsRate = 27/2048;
    let msRate = 83/2048;
    let lockRate = 268/354;
    let locksRate = 268/1024;
    //if (width / wHeight > sRate) {
      width = wHeight * sRate;
      if(width>wWidth)
      {
          width = wWidth;
          height = width/sRate;
      }
      let tWidth = width*tsRate;
      let tHeight = tWidth/tRate;
    let bWidth = width*bsRate;
    let bHeight = bWidth/bRate;
    let bbWidth = width*bbsRate;
    let bbHeight = bbWidth/bbRate;
    let mWidth = width*msRate;
    let mHeight = mWidth/mRate;
    let spaceWidth = width*33/2048;
    let lockWidth = width*locksRate;
    let lockHeight = lockWidth/lockRate;
    //}
    let fNQ = width * 0.05;
    let fVeryBig = width * 0.15;
    let fBig = width * 0.07;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
  

    if (!ACCOUNTCOMP) {

      return (<Redirect to='/competition_login' />);
    }

    let curSet = sets[curSetIndex];
    let curSetting = sets[curSetIndex].config;
    //let bWidth = STATIC.calSize(512, DWIDTH, width);
    //console.log(ACCOUNT);
    if(showRank)
    {
      return <CompRank round={_this.props.roundIndex} comp={_this.props.comp} />
    }
    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >




            <div className={classes.square} style={{maxWidth:width, width: width,height:height,backgroundImage: comp&&comp.bg_listen&&comp.bg_listen.length>0?("url('"+comp.bg_listen+"')"):"url('assets/comp/bg_listen.png')",
            backgroundPosition: "center center",
            WebkitBackgroundSize: "100% 100%",
            backgroundSize: "100% 100%",position:'relative' }} elevation={4}>

              <div style={{paddingTop:STATIC.calSize(10, DWIDTH, width) + 'px '}}>{" "}</div>
                <div onClick={()=>this.answerInput.focus()}  style={{position:'absolute',top:STATIC.calSize(100, DWIDTH, width),left:STATIC.calSize(90,DWIDTH, width),width: tWidth,height:tHeight,backgroundImage: "url('assets/comp/nq_table.png')",
                backgroundPosition: "center center",
                WebkitBackgroundSize: "100% 100%",
                backgroundSize: "100% 100%",display: 'flex',flexDirection:'row', justifyContent: 'center', alignItems: 'center',position:'relative' }} elevation={4}>

                  {message ?<div style={{fontSize:fVeryBig}}>{message}</div>:questions&&questions.length > 0&&<NumDisplay aList={this.props.aList} width={width} type={questions[curIndex].type}  size={fVeryBig} second={curSetting.showTime} sound={true} numbers={questions[curIndex].numbers} showing={showing} updateEQMessage={()=>{}} isEnd={this.isShowEnd} />}
                  {this.state.showCountDown&&<div style={{fontSize:fVeryBig}}>{this.state.answerInput}</div>}
                  <input ref={(input) => { this.answerInput = input; }} type="text" onKeyDown={this.handleKeydown} tabIndex={0} onChange={this.handleChange("answerInput")} value={answerInput} style={{zIndex:-9999, width:0,height:0 }} />

                </div>

              <div style={{width,position:'absolute',bottom:STATIC.calSize(1, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>{ACCOUNTCOMP.id}</div>

              </div>
              <div style={{width,position:'absolute',bottom:STATIC.calSize(50, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{"Nghe tính"}</div>

              </div>
              <div  style={{position:'absolute',top:STATIC.calSize(11, DWIDTH, width),left:STATIC.calSize(375,DWIDTH, width),width:width*574/2048,height:(width*574/2048)*377/1427,backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:0.8}}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
              </div>
              {showCountDown&&<div style={{position:'absolute',bottom:STATIC.calSize(70, DWIDTH, width),right:STATIC.calSize(70,DWIDTH, width)}}>
                <div className="comp_text_gradient2"  style={{fontSize:fLarge,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}><CountDown className="comp_text_gradient2" size={fTitle} second={curSetting.answerTime} isEnd={this.endCountDown} /></div>
              </div>}
              {questions&&questions.length>0&&<div style={{position:'absolute',top:STATIC.calSize(90, DWIDTH, width),left:STATIC.calSize(110,DWIDTH, width)}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{(curIndex+1)+"/"+questions.length}</div>
              </div>}
              {showCountDown&&<div style={{position:'absolute',right:20,top:20,display:'flex',justifyContent: 'center', alignItems: 'center'}}>

                <div onClick={()=>this.setState({showNumPad:false})} style={{position:'absolute',top:0,left:0,right:0,bottom:0,width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)'}}>

                </div>
                {isMobile&&<Numpad width={width * 0.3} handleClick={this.handleInputClick} />}
              </div>}
              {showLock&&<div style={{position:'absolute',top:0,left:0,right:0,bottom:0,display:'flex',flexDirection:"column",justifyContent: 'center', alignItems: 'center'}}>
              <div  style={{position:'absolute',top:0,left:0,right:0,bottom:0,width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)'}}>

              </div>
                <img src='assets/comp/lock.png'  style ={{width:lockWidth,height:lockHeight}}/>
                {nextTime!=0&&<CountDown className="comp_text_gradient2" size={fTitle} second={nextTime} isEnd={()=>{}} />}
              </div>}
              <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(280,DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src="assets/comp/sp_logo_red.png"
                  style={{ width: width*154/2048, height: 'auto', display: 'block' }} />
              </div>


            </div>

        </div>

        <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
          <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.props.online}</div>

        </div>



      </div>
    );
  }
}

CompHome.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles2)(STATIC.translate('common')(CompHome));
